import { AxiosInstance } from "axios";
import {
  CommunityStories,
  OrgBootstrap,
  CommunityEvents,
  CommunitySubCommunities,
} from "../types";
import { generateApiUrlWithQueryParams } from "../utils/query-params";

export const basePath = "/organizations";

// All the paths for this api domain.
export const organizationPaths = {
  getOrgBootstrapPath: (id: number) => basePath + `/${id}/bootstrap`,

  getStories: (id: number, queryParams?: string) =>
    generateApiUrlWithQueryParams(
      `${basePath}/${id}/volunteer-experiences`,
      queryParams
    ),

  getEvents: (id: number, queryParams?: string) =>
    generateApiUrlWithQueryParams(`${basePath}/${id}/events`, queryParams),

  getSubCommunities: (id: number, queryParams?: string) =>
    generateApiUrlWithQueryParams(
      `${basePath}/${id}/subcommunities`,
      queryParams
    ),
};

class OrganizationApi {
  api: AxiosInstance;

  constructor(api: AxiosInstance) {
    this.api = api;
  }

  // Get the org bootstrap blob.
  // GET /organizations/<id>/bootstrap
  getOrgBootstrap = (id: number) => {
    return this.api.get<OrgBootstrap>(
      organizationPaths.getOrgBootstrapPath(id)
    );
  };

  // Get the organization's (community) stories.
  // GET /organizations/<id>/volunteer-experiences
  getStories = (id: number, queryParams?: string) => {
    return this.api.get<CommunityStories>(
      organizationPaths.getStories(id, queryParams)
    );
  };

  // Get the organization's (community) events.
  // GET /organizations/<id>/events
  getEvents = (id: number, queryParams?: string) => {
    return this.api.get<CommunityEvents>(
      organizationPaths.getEvents(id, queryParams)
    );
  };

  // Get the organization's (community) subCommunities (communties with a subject type of group)
  getSubCommunities = (id: number, queryParams?: string) => {
    return this.api.get<CommunitySubCommunities>(
      organizationPaths.getSubCommunities(id, queryParams)
    );
  };
}

export default OrganizationApi;
